import { render, staticRenderFns } from "./SheetBar.vue?vue&type=template&id=589a042c&scoped=true&"
import script from "./SheetBar.vue?vue&type=script&lang=js&"
export * from "./SheetBar.vue?vue&type=script&lang=js&"
import style0 from "./SheetBar.vue?vue&type=style&index=0&id=589a042c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a042c",
  null
  
)

export default component.exports